import { getOpacityFromPattern } from '@web-stories-wp/patterns';
import type { TextBorder } from '../../types';

export function hasTextBorder(textBorder?: TextBorder) {
  if (!textBorder || textBorder.width === 0) {
    return false;
  }

  return getOpacityFromPattern(textBorder.color) > 0;
}
